import _convertToMinutesFrequency from 'app/components/pages/pad-menu/pad-initialization/components/steps/visit-schedule/schedulePrescriptionCalendars/calendarEach/scheduling/_convertToMinutesFrequency';
import _dateTimeSchedule from 'app/components/pages/pad-menu/pad-initialization/components/steps/visit-schedule/schedulePrescriptionCalendars/calendarEach/scheduling/_dateTimeSchedule';

function getDateTimes(params) {
  const {
    startDateTime,
    period,
    calendarType,
    // frequency,
    frequencyTypeId,
    frequencyAmount,
    timeStart,
    timeEnd
    //
  } = params;

  const frequencyInMinutes = _convertToMinutesFrequency({
    calendarType,
    frequencyTypeId,
    frequencyAmount
  });

  const frequency = frequencyInMinutes || params.frequency;

  const dateTimes = _dateTimeSchedule({
    startDateTime,
    period,
    frequency,
    timeStart,
    timeEnd
    //
  });

  return dateTimes;
}

export default getDateTimes;
